import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  RESET_PASSWORD, RESET_PASSWORD_ERROR, RESET_PASSWORD_SUCCESS
} from "./actionTypes"

export const userForgetPassword = (user, history) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user, history },
  }
}

export const userForgetPasswordSuccess = message => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: message,
  }
}

export const userForgetPasswordError = message => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: message,
  }
}

export const resetPasswordAction = (data, history) => {
  return {
    type: RESET_PASSWORD,
    payload: { data, history },
  }
}

export const resetPasswordSuccess = (data, history) => {
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload: { data, history },
  }
}

export const resetPasswordError = (data, history) => {
  return {
    type: RESET_PASSWORD_ERROR,
    payload: { data, history },
  }
}
